import { DeepPartial } from '@arcadiapower/shrike/dist/types/src/types';
import { merge } from 'lodash';
import { SolarFunnelMachine } from '~/machines/solar-funnel';
import { ContextSendMatch } from '~/machines/utils/types';
import {
  EnergywellPaymentVerificationFailed,
  EnergywellPaymentVerificationFailedProps,
} from './energywell-payment-verification-failed.component';

type EnergywellPaymentVerificationFailedContainerProps = {
  micro: ContextSendMatch<SolarFunnelMachine>;
  overrideCopy?: EnergywellPaymentVerificationFailedProps['overrideCopy'];
  overrideProps?: DeepPartial<EnergywellPaymentVerificationFailedProps>;
};

export const EnergywellPaymentVerificationFailedContainer = ({
  micro: { context, send },
  overrideCopy,
  overrideProps,
}: EnergywellPaymentVerificationFailedContainerProps) => {
  const props: EnergywellPaymentVerificationFailedProps = {
    context: {
      funnelPacket: context.funnelPacket,
      queryParams: context.queryParams,
    },
    next: () => send({ type: 'CONTINUE_CLICKED' }),
    overrideCopy,
  };

  return <EnergywellPaymentVerificationFailed {...merge(props, overrideProps)} />;
};
